import "es6-weak-map/implement";
import "babel-polyfill";
import { h, render, Fragment, Component as ReactDOM } from "preact";
import Widget from "./component";
import Services from "./services";
import ToastStore from "./components/toast/store";
import Toast from "./components/toast";
import reload from "./utils/reload";
import cmsApi from "./services/cms-api";
import "./style.css";
import { FORGET_PASSWORD, JX3_FORGET_ACCOUNT, XOYO_PERSONAL_CENTER } from "./constants/urls";
import replaceUrlToHttps from "./utils/replace-url-to-https";
import { isMobile } from "./utils/device-utils";
import $$tracker from "./tracker";


//toast
const toast = new ToastStore();

const XPASS = {

    /**
     * 登录框配置
     */
    loginConfig: {
      /**
       * 金山通行证登录类型,目前支持普通金山通行证登录,手机号登录
       * defaultType:打开弹窗默认登录方式,默认值:普通金山通行证登录
       * typesConfig:登录方式配置
       *    type:登录类型
       *    enable:是否显示在弹窗上
       */
      passportLoginType: {
        defaultType: "passport",
        typesConfig: [{ type: "passport", enable: true }, { type: "phone", enable: true }]
      },
      /**
       * 第三方登录类型,目前默认有wegame,微信,QQ,微博
       * type:登录类型
       * text:弹窗上显示的登录名称
       * iconUrl:登录icon,尺寸72*72
       * enable:是否显示到弹窗上
       */
      thirdLoginType: [
        {
          type: "wegame",
          text: "WeGame",
          iconUrl: "data:image/png;base64,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",
          enable: true
        },
        {
          type: "wechat",
          text: "微信",
          iconUrl: "data:image/png;base64,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",
          enable: true
        },
        {
          type: "qq",
          text: "QQ",
          iconUrl: "data:image/png;base64,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",
          enable: true
        },
        {
          type: "weibo",
          text: "微博",
          iconUrl: "data:image/png;base64,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",
          enable: true
        }
      ],
      /**
       * 忘记账号
       * enable:是否显示在弹窗上
       * url:忘记账号的跳转链接
       */
      forgetAccount: { enable: true, url: JX3_FORGET_ACCOUNT },
      /**
       * 忘记密码
       * enable:是否显示在弹窗上
       * url:忘记密码的跳转链接
       */
      forgetPassword: { enable: true, url: FORGET_PASSWORD }
    },

    //账号信息
    u_account: "",

    //当前登录类型
    loginType: "passport",

    //当同时存在通行证态和第三方登录态，是否优先使用通行证登录态 1是 0否,默认不传是1
    preferPassport: 1,

    pageLoadFinishTime: 0,

    /**
     * 获取主题的cms文章配置
     */
    theme: {
      /**
       * 是否需要开启弹窗主题皮肤,默认:关闭
       */
      enable: false,
      /**
       * cms主题配置信息
       * api:cms站点
       * categoryId:栏目id
       * articleId:文章id
       */
      // themeConfig: { api: "https://test-zt.xoyo.com/api.php", categoryId: "6250", articleId: "1" },
      themeConfig: { api: "https://jx3.xoyo.com/api.php", categoryId: "6461", articleId: "1" },

      /**
       * cms默认主题信息
       * api:cms站点
       * categoryId:栏目id
       * articleId:文章id
       * moreInfo:是否拉取副表字段
       */
      defaultConfig: {
        // api: "https://test-zt.xoyo.com/api.php",
        api: "https://jx3.xoyo.com/api.php",
        // categoryId: "6248",
        categoryId: "6463",
        articleId: "1",
        moreInfo: 1
      },

      /**
       * cms自由风格主题信息
       * api:cms站点
       * categoryId:栏目id
       * articleId:文章id
       * moreInfo:是否拉取副表字段
       */
      autoConfig: {
        // api: "https://test-zt.xoyo.com/api.php",
        api: "https://jx3.xoyo.com/api.php",
        // categoryId: "6246",
        categoryId: "6464",
        articleId: "1",
        moreInfo: 1
      }

    },

    //主题风格背景图
    themeImgs: {
      top: "",
      middle: "",
      bottom: ""
    },

    //XPASS出发
    init: async function() {
      await this.getThemeConfig();
      await this.getPassportLoginInfo();
      await this.getThirdLoginInfo();
      this.pageLoadFinishTime = this.getCurrentSecond();

      $$tracker.webLoading();
    },

    //登录成功回调
    onLoginSuccess: () => {
      reload();
    },

    //注册成功回调
    onRegisterSuccess: () => {
    },

    //渲染弹窗
    rending: (params) => {
      let node = document.createElement("div");

      node.id = "__XFE_LOGIN_MODAL__";
      render((
        <>
          <Widget render={params}/>
          <Toast store={toast}/>
        </>
      ), node);
      document.body.appendChild(node);
    },

    /**
     * 获取金山通行证登录信息
     * @returns {Promise<void>}
     */
    getPassportLoginInfo: async function(userCallback) {
      await Services.getPassportLoginInfo().then(result => {
        // console.info("passport:", result);
        this.u_account = result?.account;
        $$tracker.webIsLoginOk();
        this.setAccountInfo();
        userCallback && userCallback();
      }).catch(err => {
        if (err?.code !== -20101 /* 请先登录 */) {
          this.toastOpen(err?.message);
        }

      });
    },

    /**
     * 获取第三方登录信息
     * @returns {Promise<void>}
     */
    getThirdLoginInfo: async function(userCallback) {
      await Services.getThirdLoginInfo().then(result => {
        // console.info("third:", result);
        this.loginType = result?.login_type;
        this.u_account = result?.nickname;
        if (result?.login_type === "qq") {
          $$tracker.webIsLoginOkByQQ();
        }
        this.setAccountInfo();
        userCallback && userCallback();
      }).catch(err => {
        console.info("第三方登录信息接口err:", err?.message);
      });
    },

    /**
     * 获取主题配置
     * @returns {Promise<void>}
     */
    getThemeConfig: async function() {
      if (this.theme.enable) {
        await cmsApi.getArticleDetail(this.theme.themeConfig).then(async result => {
          if (result?.data[0]?.is_default_theme === "true") {
            await this.getDefaultThemeConfig();
          } else {
            await this.getAutoThemeConfig();
          }
        }).catch(err => {
          console.info("获取主题配置错误:", err);
        });
      }

    },

    /**
     * 获取默认主题
     * @returns {Promise<void>}
     */
    getDefaultThemeConfig: async function() {
      await cmsApi.getArticleList(this.theme.defaultConfig).then(result => {
        // console.info("default:", result,result?.list[0]?.default_theme_imgs);
        if (result?.list?.length > 0) {
          this.getThemeImgs(JSON.parse(result?.list[0]?.default_theme_imgs));
        }

      }).catch(err => {
        console.info("获取默认主题错误:", err);
      });
    },

    /**
     * 获取自由主题
     * @returns {Promise<void>}
     */
    getAutoThemeConfig: async function() {
      await cmsApi.getArticleList(this.theme.autoConfig).then(async result => {
        // console.info("auto:", result);
        this.getAutoTheme(result?.list);
      }).catch(err => {
        console.info("获取自由主题错误:", err);
      });
    },


    /**
     * 整理自由风格的id集合
     * @param list
     */
    getAutoTheme: function(list) {
      if (list?.length > 0) {
        let date = new Date().getTime();
        let startDate, endDate;
        list.map((item) => {
          startDate = new Date((item.theme_start_time).replace(/-/g, "/")).getTime();
          endDate = new Date((item.theme_end_time).replace(/-/g, "/")).getTime();
          if (date >= startDate && date <= endDate) {
            this.getThemeImgs(JSON.parse(item?.auto_theme_imgs));
          }
        });
      }
    },

    /**
     * 获取主题图片
     * @param imgs
     */
    getThemeImgs: function(imgs) {
      if (imgs) {
        let theme = this.themeImgs;
        Object.keys(imgs).forEach(key => {
          const item = imgs[key];
          if (item.alt === "top") {
            theme.top = replaceUrlToHttps(decodeURIComponent(item.url));
          } else if (item.alt === "middle") {
            theme.middle = replaceUrlToHttps(decodeURIComponent(item.url));
          } else if (item.alt === "bottom") {
            theme.bottom = replaceUrlToHttps(decodeURIComponent(item.url));
          }
        });

        this.themeImgs = { ...theme };
      }

    },

    /**
     * 设置登录信息
     */
    setAccountInfo: function() {
      const accountTag = document.getElementsByClassName("t_xpass_signin_u_i")[0];
      if (accountTag) {
        let accontHtml = `<a class="t_xpass_signin_u_name_i" href=""${XOYO_PERSONAL_CENTER} style="display:block;"><span>`;
        if (this.loginType === "wegame") {
          accontHtml += `WeGame身份码:${this.u_account}`;
        } else if (this.loginType === "qq") {
          accontHtml += `您好，QQ用户:${this.u_account}`;
        } else if (this.loginType === "wechat") {
          accontHtml += `您好，微信用户:${this.u_account}`;
        } else if (this.loginType === "weibo") {
          accontHtml += `您好，微博用户:${this.u_account}`;
        } else {
          accontHtml += this.u_account;
        }
        accontHtml += `</span></a><a class="t_xpass_s_out" onclick="window.XPASS.exit()"><span>退出</span></a>`;

        accountTag.innerHTML = accontHtml;

        if (document.querySelector(".XPASS_signin")) {
          document.querySelector(".XPASS_signin").style.display = "none";
        }

      }

    }
    ,

    /**
     * 弹窗提示
     * @param msg
     */
    toastOpen: function(msg) {
      toast.visible = true;
      toast.msg = msg;
    },

    /**
     * 点击登录
     * @param props 例如:props={onLoginSuccess:()=>{console.log('登录成功回调')},source:101}
     */
    signin: function(props = {}) {
      const { onLoginSuccess } = props;
      if (onLoginSuccess) {
        this.onLoginSuccess = onLoginSuccess;
      }
      $$tracker.tabLoginClick();
      this.rending(Object.assign(props, { type: 0 }));
    },

    /**
     * 点击注册
     * @param props 例如:props={onRegisterSuccess:()=>{console.log('注册成功回调')},source:202}
     */
    signup: function(props = {}) {
      const { onRegisterSuccess } = props;
      if (onRegisterSuccess) {
        this.onRegisterSuccess = onRegisterSuccess;
      }
      this.rending(Object.assign(props, { type: 1 }));

      $$tracker.tabRegClick();
    }
    ,

    /**
     * 退出
     * @param userCallback
     * @returns {Promise<void>}
     */
    exit: async function(userCallback) {
      if (this.loginType === "qq" || this.loginType === "wechat" || this.loginType === "weibo") {
        this.exitThird(userCallback);
      } else {
        this.exitPassport(userCallback);
      }
    }
    ,

    /**
     * 第三方退出 QQ、微信、微博
     * @param userCallback
     */
    exitThird: async function(userCallback) {
      await Services.exitThird().then(() => {
        this.toastOpen("退出成功");
        reload();
        userCallback && userCallback();
      }).catch(err => {
        this.toastOpen(err?.message);
      });
    }
    ,

    /**
     * 金山通行证退出
     * @param userCallback
     */
    exitPassport: async function(userCallback) {
      await Services.exitPassport().then(() => {
        this.toastOpen("退出成功");
        reload();
        userCallback && userCallback();
      }).catch(err => {
        this.toastOpen(err?.message);
      });
    },

    /**
     * 获取当前秒数
     * @returns {number}
     */
    getCurrentSecond: function() {
      return parseInt(new Date().getTime() / 1000);
    }

  }
;

(function() {
  XPASS.init();
})();

export default XPASS;





